/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { appendObjectValuesToFormData } from '@veone/ngx-utilities/form';
import { Observable } from 'rxjs';
import { SKIP_ERROR_INTERCEPTOR } from '~core/constants/global.constants';
import {
  RelatedObjectName,
  Attachment,
  AttachmentListParams,
  Pagination,
  AttachmentCreationParams
} from '~core/models/core.models';
import { ApiConstantsService } from './api-constants.service';

@Injectable()
export class AttachmentService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  read(
    attachmentId: string,
    attachmentName: RelatedObjectName
  ): Observable<Attachment> {
    return this._httpClient.get<Attachment>(
      `${this._apiConstantsService.attachmentUrl}/${attachmentId}/${attachmentName}`
    );
  }

  list(params?: AttachmentListParams): Observable<Pagination<Attachment>> {
    return this._httpClient.get<Pagination<Attachment>>(
      this._apiConstantsService.attachmentUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  create(
    data: AttachmentCreationParams,
    skipErrorInterceptor?: boolean
  ): Observable<Attachment> {
    const formData = new FormData();
    appendObjectValuesToFormData(formData, data);

    return this._httpClient.post<Attachment>(
      this._apiConstantsService.attachmentUrl,
      formData,
      {
        ...(skipErrorInterceptor && {
          context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
        })
      }
    );
  }

  update(
    attachmentId: string,
    relatedObjectName: RelatedObjectName,
    data: Partial<AttachmentCreationParams>
  ): Observable<Attachment> {
    let formData: Partial<Attachment> | FormData = data;
    if (data.file) {
      formData = new FormData();
      appendObjectValuesToFormData(formData, data);
    }
    return this._httpClient.post<Attachment>(
      `${this._apiConstantsService.attachmentUrl}/${attachmentId}/${relatedObjectName}`,
      formData
    );
  }

  delete(
    attachmentId: string,
    attachmentName: RelatedObjectName
  ): Observable<unknown> {
    return this._httpClient.delete(
      `${this._apiConstantsService.attachmentUrl}/${attachmentId}/${attachmentName}`
    );
  }
}
